import Logo from '../assets/img/logo-48.png';

const Splash = () => {
  return (
    <div className='Splash'>
      <img src={Logo} alt="" />
    </div>
  )
}

export default Splash;